import React, { useState, useRef, useEffect } from 'react';
import styles from './style.module.css';

const statusOptions = [
  { value: "agreement_broken", label: "Acordo quebrado" },
  { value: "generated", label: "Acordo emitido" },
  { value: "paid", label: "Acordo quitado" },
  { value: "pending", label: "Acordo em progresso" },
  { value: "viewed", label: "Acordo consultado" },
  { value: "collections_suspended", label: "Cobranças suspensas" },
  { value: "contacted", label: "Contato realizado" },
  { value: "scheduled_contact", label: "Contato agendado" },
  { value: "cpc", label: "CPC" },
  { value: "cpe", label: "CPE" },
  { value: "deceased", label: "Falecido" },
  { value: "deny_pending", label: "Não reconhece pendência" },
  { value: "new_condition", label: "Nova condição" },
  { value: "indirect_payment", label: "Pagamento indireto" },
  { value: "waiting_payment", label: "Pendente" },
  { value: "promise_to_pay", label: "Promessa de pagamento" },
  { value: "confirm_pending", label: "Reconhece pendência" },
  { value: "no_interest", label: "Sem interesse na proposta" },
  { value: "not_return", label: "Sem retorno" },
  { value: "without_terms_payment", label: "Sem condições de pagamento" },
  { value: "suspected_fraud", label: "Suspeita de fraude" },
  { value: "payment_options_available", label: "Possui condições de pagamento" },
  { value: "handoff_requested", label: "Transbordo solicitado" },
  { value: "open_charge", label: "Cobrança em aberto" }
];

const StatusSelector = ({ selectedStatus = [], handleStatusChange = () => {}, label, excludeStatuses = [] }) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const visibleOptions = statusOptions.filter(
    (option) => !excludeStatuses.includes(option.value)
  );

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleCheckboxChange = (value, e) => {
    e.stopPropagation();
    if (!handleStatusChange) return;
    
    const newSelectedStatus = selectedStatus.includes(value)
      ? selectedStatus.filter(status => status !== value)
      : [...selectedStatus, value];
    
    handleStatusChange(newSelectedStatus);
  };

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const getSelectedText = () => {
    if (!selectedStatus || selectedStatus.length === 0) return "Selecione um status";
    if (selectedStatus.length === 1) {
      const selected = visibleOptions.find(opt => opt.value === selectedStatus[0])
        || statusOptions.find(opt => opt.value === selectedStatus[0]);
      return selected ? selected.label : "1 status selecionado";
    }
    return `${selectedStatus.length} status selecionados`;
  };

  const handleLabelClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className={styles.selectorContainer} ref={wrapperRef}>
      {label && <label htmlFor="statusSelect">{label}</label>}
      <div className={isOpen ? `${styles.selectWrapper} ${styles.active}` : styles.selectWrapper}>
        <div className={styles.selectedDisplay} onClick={toggleDropdown}>
          <span>{getSelectedText()}</span>
          <span className={styles.arrow}>{isOpen ? "▲" : "▼"}</span>
        </div>
        <div className={styles.checkboxList}>
          {visibleOptions.map((option) => (
            <label 
              key={option.value} 
              className={styles.checkboxItem}
              onClick={handleLabelClick}
            >
              <input
                type="checkbox"
                checked={selectedStatus?.includes(option.value)}
                onChange={(e) => handleCheckboxChange(option.value, e)}
              />
              <span>{option.label}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatusSelector;
